import { SYS_API_URL } from '../../comm/config';
import { rewriteRequestHeaders } from '../../utils/check';
import http from '../axios';
import { rewriteOBJ, rewriteParams } from '../commlogic';

const API_HOST = SYS_API_URL;

const POST_LIST = {
  createSysRole: '/create/sysRole',
  createSysUser: '/create/sysUser',
  updateSysRole: '/update/sysRole',
  updateSysUser: '/update/sysUser',
  healthcheckV2: '/ping',
  createSysWard: '/create/sysWard',
  updateWard: '/update/sysWard',
  updateSysDataMapping: '/update/sysDataMapping',
  postCorpIdVerify: '/corpId/verify',
  createSysNotification: '/create/sysNotification',
  getEhandNotification: '/ehdNotification/list',
  pinNotification: '/top/ehdNotification',
  deleteNotification: '/del/sysNotification',
  postNotificationFile: '/sysNotification/file',
  deleteNotificationFile: '/del/file',
  getSysNotificationFile: '/file/list',
  postForward: '/forward/sysNotification',
  addEquipmentCategory: '/create/eqCategory',
  editEquipmentCategory: '/update/eqCategory',
  getEquipmentCategoryList: '/eqCategory/list',
  listConnect: '/wpAlarm/connect',
  updateLisStatus: '/wpAlarm/status',
  driveClickrate: '/drive/clickrate',
  createHospital: '/create/sysHospital',
  updateHospital: '/update/sysHospital',
  createHospitalTag: '/create/hospitalTag',
  deleteHospitalTag: '/delete/hospitalTag',
  updateHospitalTag: '/update/hospitalTag',
  createWardTag: '/create/wardTag',
  deleteWardTag: '/delete/wardTag',
  updateWardTag: '/update/wardTag',
  ssoLogin: '/sysCorp/ssoLogin',
  seenSysNotification: '/sysNotification/visit',
  getHospCategoryRemarkList: '/hospCategoryRmk/list',
  createHospCategoryRemark: '/create/equipmentRemark',
  updateHospCategoryRemark: '/update/equipmentRemark',
  getEquipmentRemarkList: '/equipmentRemark/list',
};

const GET_LIST = {
  getSysPermissionList: '/sysPermission/list',
  getSysRoleList: '/sysRole/list',
  getSysUserList: '/sysUser/list',
  healthcheck: '/ping',
  getSysHospitalList: '/sysHospital/list',
  getSysHospitalWardList: '/sysHospitalWard/list',
  getSysWardList: '/sysWard/list',
  getSysUserRole: '/sysUser/role',
  getSysRoleTypeDetail: '/sysRoleType/detail',
  getSysDataMappingList: '/sysDataMapping/list',
  getSysWardItemList: '/sysWardItem/list',
  getSysNotificationList: '/sysNotification/list',
  getSysWardDropList: '/sysWardDrop/list',
  sysNotificationRedDot: '/sysNotification/redDot',
  sysHospitalCodeList: '/sysHospitalCode/list',
  sysHospitalUnitList: '/sysHospitalUnit/list',
  getSysNotificationTotal: '/sysNotification/total',
  getNotificationRoomType: '/sysNotification/roomType',
  getEquipmentMasterCategoryList: '/eqMasterCategory/list',
  getEquipmentCategoryWardDropdown: '/eqCategory/item',
  getSysGlobalFrontConfigList: '/sysGlobalFrontConfig/list',
  getHospitalTagList: '/hospitalTag/list',
  getWardTagList: '/wardTag/list',
  getAdsList: '/adsWardLocation/list',
  getAdsServiceType: '/adsServiceType/list',
  getDisplayMessage: '/displayMessage/list',
  getSysUserRoleItem: '/sysUser/roleItem',
};

const SYSAPI = {
  POST: POST_LIST,
  GET: GET_LIST,
};

rewriteOBJ(SYSAPI, API_HOST);

const verifySystemUserRequest = (data) => {
  const rewriteData = rewriteParams(data);
  const { headers } = rewriteData;
  const newHead = rewriteRequestHeaders(headers);
  return http.post(`${API_HOST}/sysUser/verifysysUser`, data, { headers: { ...newHead } });
};

export default { ...SYSAPI.GET, ...SYSAPI.POST, verifySystemUserRequest };
